import React from "react";
import { Select,
    MenuItem,
    FormControl,
    TextField,
    Grid,
    FormControlLabel,
    FormHelperText
 } from "@mui/material";
import { icons } from "@mui/icons-material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from '@mui/material';

 const AcademicInfoStep = ({formData, errors, onChange, showPassword, handleClickPasswordShowOff})=>{
    // console.log('formData in AcademicInfoStep:', formData); 
    return(
        <>
        <Grid container spacing={3}>
            <Grid item xs ={12} md={6}>
                <FormControl fullWidth error={!!errors.grade}>
                    {/* <label>Grade</label> */}
                    <Select
                    // label="Grade"
                    value={formData.grade}
                    onChange={(e)=> onChange('grade', e.target.value)}
                    displayEmpty
                    helperText={errors.grade}
                    >
                    <MenuItem value=""> Select Grade</MenuItem>
                    <MenuItem value="1st">1st</MenuItem>
                    <MenuItem value="2nd">2nd</MenuItem>
                    <MenuItem value="3rd">3rd</MenuItem>
                    <MenuItem value="4th">4th</MenuItem>
                    <MenuItem value="5th">5th</MenuItem>
                    <MenuItem value="6th">6th</MenuItem>
                    <MenuItem value="7th">7th</MenuItem>
                    <MenuItem value="8th">8th</MenuItem>
                    <MenuItem value="9th">9th</MenuItem>
                    </Select>
                    {errors.grade && <FormHelperText>{errors.grade}</FormHelperText>}
                </FormControl>
            </Grid>
            <Grid item xs ={12} md={6}>
                <FormControl fullWidth error={!!errors.board}>
                    {/* <label>Board</label> */}
                    <Select
                    // label="Board"
                value={formData.board}
                onChange={(e)=> onChange('board', e.target.value)}                
                helperText={errors.board}
                    displayEmpty
                    >
                    <MenuItem value="">Select Board</MenuItem>
                    <MenuItem value="CBSE">CBSE</MenuItem>
                    <MenuItem value="State">State</MenuItem>
                    <MenuItem value="ICSE">ICSE</MenuItem>
                    </Select>
                    {errors.board && <FormHelperText>{errors.board}</FormHelperText>}                    
                </FormControl>
            </Grid>
           
            <Grid item sx={12} md={6}>
                <TextField
                fullWidth
                label="Password"
                type={showPassword.password1 ? "text" : "password"}
                value={formData.password}
                onChange={(e)=> onChange('password', e.target.value)}
                error={!!errors.password}
                helperText={errors.password}
                InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" sx={{marginLeft:"10px", marginRight:"10px"}}>
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={()=> handleClickPasswordShowOff('password1')}
                              edge="end"
                            >
                              {showPassword.password1 ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                />
            </Grid>
            <Grid item sx={12} md={6}>
                <TextField
                fullWidth
                label="Confirm Password"
                type={showPassword.password2 ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={(e)=> onChange('confirmPassword', e.target.value)}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" sx={{marginLeft:"10px", marginRight:"10px"}}>
                            <IconButton 
                              aria-label="toggle password visibility"
                              onClick={()=> handleClickPasswordShowOff('password2')}
                              edge="end" 
                            >
                              {showPassword.password2 ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                />
            </Grid>
            
        

        </Grid>
        </>
    )
 }

 export {AcademicInfoStep}